import React from 'react';
import type { SpacerBlockContent } from '../../../types/popup.types';

interface SpacerBlockProps {
  content: SpacerBlockContent;
}

const SpacerBlock: React.FC<SpacerBlockProps> = ({ content }) => {
  const { height } = content;

  return <div style={{ height: `${height || 24}px` }} />;
};

export default SpacerBlock;
